export default {
  head_scripts: {
    title: 'Head-Skripte',
  },
  body_noscripts: {
    title: 'Body-Noskripte',
    description: 'Code direkt nach dem Öffnen des Bodys einfügen',
  },
  google_site_verification: {
    title: 'Google-Site-Verifizierung',
    label: 'Google-Site-Verifizierungscode',
  },
  buttons: {
    save: 'Speichern',
  },
};
